import { render, staticRenderFns } from "./EditCustomerDialog.vue?vue&type=template&id=43163978&scoped=true&"
import script from "./EditCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./EditCustomerDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerDialog.vue?vue&type=style&index=0&id=43163978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43163978",
  null
  
)

export default component.exports